// apps/client/src/routes/guards/RequireEdmImportAccess.tsx
//
// Company-wide gate for /leads/edm/import. Imports are company-wide, so the
// import callable and the storage rule admit super_admin, marketing, and an
// administrator only with canSeeAllOffices. Without this guard an
// office-scoped administrator (who passes the /leads/edm tab entry) could
// upload a contact file to Storage that the callable then refuses to read.
// View-as forces canSeeAllOffices=false, which only narrows.

import React from 'react';
import { useOutletContext, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { canImportEdmContacts } from '../../utils/edm';

interface AppOutletContext {
  userData?: { role?: string };
}

const RequireEdmImportAccess: React.FC = () => {
  const outletContext = useOutletContext<AppOutletContext>();
  const { claims } = useAuth();
  const role = outletContext?.userData?.role ?? claims?.role;
  if (!canImportEdmContacts(role, claims?.canSeeAllOffices)) {
    return <Navigate to="/leads/edm" replace />;
  }
  return <Outlet context={outletContext} />;
};

export default RequireEdmImportAccess;
